import { render, staticRenderFns } from "./OurCulture.vue?vue&type=template&id=3e3b18ba&scoped=true&"
import script from "./OurCulture.vue?vue&type=script&lang=ts&"
export * from "./OurCulture.vue?vue&type=script&lang=ts&"
import style0 from "./OurCulture.vue?vue&type=style&index=0&id=3e3b18ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b18ba",
  null
  
)

export default component.exports